import Modal from 'bootstrap/js/dist/modal';
import Tooltip from 'bootstrap/js/dist/tooltip';

$(document).ready(function(){
	$('#header').addClass('no-gradient');
	if( typeof events === 'undefined' || events === null ){
		events={};
	}

	var calendar = jQuery("#calendar"),
	cal=false;

	if(calendar.length){
		cal = calendar.calendario({
			caldata: events,
			displayWeekAbbr: true,
			events: 'click',
			fillEmpty: true,
			startIn : 0,
			weekabbrs:['S', 'M', 'T', 'W', 'T', 'F', 'S'],
		});
	}

	const $noEvents=$('#noEvents');
	const $allEvents=$('#eventList .single-event');
	const $monthYearLabel=$('.month-year h1');
	function updateMonthYear() {
		addToolTips();
		$monthYearLabel.html(cal.getMonthName()+" "+cal.getYear())
		$noEvents.hide();
		$allEvents.hide();
		const eventsToShow=$('#eventList .single-event[data-monthyear='+cal.getMonth()+'-'+cal.getYear()+']');
		if(eventsToShow.length){
			eventsToShow.show();
		}else{
			$noEvents.show();
		}

	}

	jQuery('.next-month').on('click', function() {
		cal.gotoNextMonth(updateMonthYear);
	});
	jQuery('.prev-month').on('click', function() {
		cal.gotoPreviousMonth(updateMonthYear);
	});

	function addToolTips(){
		jQuery("#calendar .fc-content").each(function(i,elem){
			var $this = $(elem);
			$this.find('time').remove();
			var span = $this.find(".fc-calendar-event").html();
			if(span){
				$this.attr("title",span).attr('data-toggle','tooltip').tooltip({
					animation:true,
					html:true,
					placement:'bottom',
					container:'.calendar-container',
					debug:true
				});
				$this.find('.fc-calendar-event').remove();
			}
		});
	}

	function hidePastEvents(){
		$('#calendar .fc-past.fc-content').removeClass('fc-content').tooltip('dispose');
		$('#eventList .past-event').hide();
	}
	if(cal){
		updateMonthYear();
		hidePastEvents();

		var urlParams = new URLSearchParams(window.location.search);
		if(urlParams.has('m')){
			cal.gotoMonth(urlParams.get('m'), cal.getYear(), updateMonthYear);
		}
	}
});